import { render, staticRenderFns } from "./registrationCards.vue?vue&type=template&id=f28afe54"
import script from "./registrationCards.vue?vue&type=script&lang=js"
export * from "./registrationCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports